import { getVersion } from '@/utils/requestHandler.js'
import licenses from '@/license.json'

export default {
   name: 'About',
   data() {
      return {
         apiVersionResponse: '',
         licenseResponse: ''
      }
   },
   async created() {
      this.apiVersionResponse = await getVersion()
      if (typeof this.apiVersionResponse == 'string') {
         if (this.apiVersionResponse.includes('Request failed') || this.apiVersionResponse.toLowerCase().includes('error')) {
            this.error = this.apiVersionResponse
            console.log(this.error)
            this.loading = false
         }
      }
      this.licenseResponse = licenses
      this.loading = false
   }
}
